import { render, staticRenderFns } from "./TableRatesSidebar.vue?vue&type=template&id=f49987dc&scoped=true&"
import script from "./TableRatesSidebar.vue?vue&type=script&lang=js&"
export * from "./TableRatesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49987dc",
  null
  
)

export default component.exports